import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-case-list-card',
  templateUrl: './case-list-card.component.html',
  styleUrls: ['./case-list-card.component.css']
})
export class CaseListCardComponent implements OnInit {

  constructor() { }

  @Input() cases;
  @Input() x;
  @Output() navAction = new EventEmitter();
  @Output() propAction = new EventEmitter();

  ngOnInit() {
  }

  navigate(data) {
    this.navAction.emit(data);

  }

  propogate(data) {
    this.propAction.emit(data);
  }

}
